import React from "react";
import { TouchableOpacity, View } from "react-native";

import Svg, { Path } from "react-native-svg";

export default function AppleHealthIcon(props) {
  const w = props.width || 30;
  const h = props.height || 30;

  const TAG = props.onPress ? TouchableOpacity : View;

  return (
    <TAG style={props.styles} {...props}>
      <Svg width={w} height={h} viewBox="0 0 512 512" fill="none">
        <Path
          fill="#F2F2F2"
          d="M407,512H105C47.103,512,0,464.897,0,407V105C0,47.103,47.103,0,105,0h302
	c57.897,0,105,47.103,105,105v302C512,464.897,464.897,512,407,512z"
        />
        <Path
          fill="#F2F2F2"
          d="M407,0H256v512h151c57.897,0,105-47.103,105-105V105C512,47.103,464.897,0,407,0z"
        />
        <Path
          fill="#DD2E44"
          d="M321,284.646C260.885,246.316,211,207.66,211,146c0-33.137,26.863-60,60-60
	c20.875,0,39.252,10.666,50,26.839C331.748,96.666,350.125,86,371,86c33.137,0,60,26.863,60,60
	C431,207.66,381.115,246.316,321,284.646z"
        />
        <Path
          fill="#DD2E44"
          d="M371,86c-20.875,0-39.252,10.666-50,26.839C310.252,96.666,291.875,86,271,86
	c-5.18,0-10.206,0.656-15,1.891V236.75c18.291,17.002,40.816,32.476,65,47.896C381.115,246.316,431,207.66,431,146
	C431,112.863,404.137,86,371,86z"
        />
      </Svg>
    </TAG>
  );
}
